export enum LeftPaneState {
    OPEN = 'open',
    CLOSED = 'closed'
}
